module.exports = "/build/admin/images/favicon-32x32.5f4ab4a4.png";